import WaysUse from "./WaysUse";
import './index.css';

export default WaysUse;